import { Component, OnInit } from "@angular/core";
import moment from "moment";
import {
  JobProcedureSummaryReview,
  JobProcedureFormDetails
} from "src/app/models/job-procedure-summary-review.model";
import { Router, ActivatedRoute } from "@angular/router";
import { GlobalSettingsService } from "src/app/services/ui/global-settings.service";
import { JobProcedureFormCopilotConfirmation } from "src/app/models/procedure-copilot-confirmation-details.model";
import { TokenHelper } from "src/app/services/helpers/token.helper";
import { ToastService } from "src/app/services/ui/toast.service";
import { ToastType } from "../toast/models/toast-type.enum";
import { JobProcedureService } from "src/app/services/sections/job/job-procedure.service";
import { ProcedureFormIconColorMap } from "src/app/models/job-procedure-summary-review.model";

@Component({
  selector: "procedure-summary-review",
  templateUrl: "./procedure-summary-review.component.html",
  styleUrls: [
    "./procedure-summary-review.component.scss",
    "../job-details/job-details.component.scss",
    "../stylesheets/job-actions.scss",
    "../stylesheets/job-main.scss",
  ],
})
export class ProcedureSummaryReviewComponent implements OnInit {
  public readonly moment = moment;
  public readonly ProcedureFormIconColorMap = ProcedureFormIconColorMap;

  public summaryReviewProcedure: JobProcedureSummaryReview = {} as JobProcedureSummaryReview;

  public loadingFormId: number | null = null;
  public expandedStepIndex: number = -1;

  public trackByJobProcedureFormId = (
    index: number,
    step: JobProcedureFormDetails,
  ): number => {
    return step.jobProcedureFormId;
  };

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private procedureService: JobProcedureService
  ) {}

  ngOnInit(): void {
    this.summaryReviewProcedure = this.activatedRoute.snapshot.data['summaryReviewProcedure'] as JobProcedureSummaryReview;
  }

  ngAfterViewInit(): void {
    GlobalSettingsService.isGlobalLoaderLoading = false;
    GlobalSettingsService.isSecondaryLoaderLoading = false;
  }

  goToFormDetails(step: JobProcedureFormDetails) {
   if(!step) {
      console.error('No step provided to navigate to form details.');
      return;
    }
    this.router.navigate([`./${step.jobProcedureFormId}/form-details`], {relativeTo: this.activatedRoute,  state:{procedureName:step.stepName, expandedStepIndex:this.expandedStepIndex, isFromSummaryReview:true} });
  }

  handleReportAction(): void {
    if (this.summaryReviewProcedure.procedureSummaryDocumentId) {
      window.open(this.summaryReviewProcedure.documentUrl, '_blank', 'noopener');
    } else {
      this.loadingFormId = -1;
      this.procedureService.generateProcedureSummaryReport(TokenHelper.getToken(this.activatedRoute), this.summaryReviewProcedure.jobId).subscribe(
        () => {
          ToastService.pushToast({
            text: 'Report generation initiated successfully. Please check the document after some time.',
            icon: 'success',
            type: ToastType.Success
          });
          this.loadingFormId = null;
        },
        (error) => {
          console.error('Error generating report', error);
          ToastService.pushToast({
            text: 'Unable to generate report. Please try again!',
            icon: 'error',
            type: ToastType.Error
          });
          this.loadingFormId = null;
        }
      );
    }
  }
}
